/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventSceneManagementUpdateResponse } from './EventSceneManagementUpdateResponse';

export type EventSceneManagementUpdateResponseApiRespoonse = {
    data?: EventSceneManagementUpdateResponse;
    status?: EventSceneManagementUpdateResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventSceneManagementUpdateResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

